// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_e27_threaded_base/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_e27_threaded_base: ModuleSchema = {
  "id": "core_e27_threaded_base",
  "uniqueId": "B3D_E27TB",
  "createdAt": "2026-10-02T05:58:41.248Z",
  "updatedAt": "2026-10-28T14:58:31.821Z",
  "label": "E27 Post Ring",
  "description": "Parametric E27 desk lamp base with central M60 threaded post and Ø41.5mm hole, designed to clamp lamp shades using core_e27_ring",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_E27"
  ],
  "sliders": [
    {
      "key": "baseDia",
      "label": "Base Disc Diameter (Ø)",
      "min": 100,
      "max": 160,
      "step": 1,
      "default": 130,
      "unit": "mm"
    },
    {
      "key": "baseH",
      "label": "Base Disc Height",
      "min": 20,
      "max": 50,
      "step": 1,
      "default": 35,
      "unit": "mm"
    },
    {
      "key": "edgeR",
      "label": "Base Rim Fillet Radius",
      "min": 2,
      "max": 12,
      "step": 0.5,
      "default": 7,
      "unit": "mm"
    },
    {
      "key": "towerR",
      "label": "Central Threaded Post Radius (Ø60=30mm)",
      "min": 25,
      "max": 35,
      "step": 0.5,
      "default": 30,
      "unit": "mm"
    },
    {
      "key": "towerH",
      "label": "Central Threaded Post Height",
      "min": 18,
      "max": 35,
      "step": 1,
      "default": 25,
      "unit": "mm"
    },
    {
      "key": "holeDia",
      "label": "Central E27 Socket Through-Hole (Ø)",
      "min": 38,
      "max": 45,
      "step": 0.5,
      "default": 41.5,
      "unit": "mm"
    },
    {
      "key": "threadPitch",
      "label": "Post Thread Pitch",
      "min": 2,
      "max": 4.5,
      "step": 0.5,
      "default": 4,
      "unit": "mm"
    },
    {
      "key": "cableTunnelDia",
      "label": "Bottom Cable Tunnel Diameter (Ø)",
      "min": 6,
      "max": 12,
      "step": 0.5,
      "default": 8,
      "unit": "mm"
    },
    {
      "key": "screwPcd",
      "label": "Feet Screws PCD (Ø)",
      "min": 70,
      "max": 110,
      "step": 1,
      "default": 85,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "e27_threaded_base",
      "label": "E27 Threaded Post Base",
      "default": "#0284c7",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "e27_retaining_ring",
      "label": "E27 Raised Half-Round Locking Ring",
      "default": "#f59e0b",
      "targetGroupIds": [
        4
      ]
    }
  ],
  "objects": [
    {
      "id": "e27_threaded_base_obj",
      "label": "E27 Threaded Post Base + Locking Ring",
      "name": "E27 Threaded Post Base + Locking Ring",
      "color": "#0284c7",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "e27_threaded_base",
          "label": "E27 Threaded Post Base",
          "name": "E27 Threaded Post Base",
          "groupId": 0,
          "colorKey": "e27_threaded_base",
          "defaultColor": "#0284c7",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        },
        {
          "id": "e27_retaining_ring",
          "label": "E27 Raised Half-Round Locking Ring",
          "name": "E27 Raised Half-Round Locking Ring",
          "groupId": 4,
          "colorKey": "e27_retaining_ring",
          "defaultColor": "#f59e0b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": []
};
